import { render, staticRenderFns } from "./DetailHistoryTemanTreasury.vue?vue&type=template&id=4d5198e8"
import script from "./DetailHistoryTemanTreasury.vue?vue&type=script&lang=js"
export * from "./DetailHistoryTemanTreasury.vue?vue&type=script&lang=js"
import style0 from "./DetailHistoryTemanTreasury.vue?vue&type=style&index=0&id=4d5198e8&prod&lang=css"
import style1 from "./DetailHistoryTemanTreasury.vue?vue&type=style&index=1&id=4d5198e8&prod&lang=css"
import style2 from "spinkit/scss/spinkit.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports